

export const getCalibrationPrintHtml = (assetData, companyName,logoSrc) => {
  if (!assetData || !assetData.main) {
    return "<html><body><p style='color:red; text-align:center;'>Asset data is not available for printing.</p></body></html>";
  }

  const main = assetData.main;
  const calibrations = assetData.calibrations || [];
  const items = assetData.items || [];
  const spares = assetData.spares || [];
  const datePart = (dateStr) => dateStr?.split('T')[0] || '-';

  const companyInfo = (assetData.Table4 && assetData.Table4.length > 0) ? assetData.Table4[0] : {};
  const address1 = companyInfo.Address1 || "";
  const address2 = companyInfo.Address2 || "";
  const pincode = companyInfo.Pincode || "";
  const email = companyInfo.Email || "";
  const phone = companyInfo.Phone || "";


  const generateTableRows = (data, headers, type) => {
    if (data.length === 0) return `<tr><td colspan="${headers.length}" style="text-align:center; color:#9ca3af;">No ${type} data available.</td></tr>`;
    
    return data.map(row => {
      let cells = '';

      if (type === 'calibration') {
          cells = `
          <td>${row.CalibrationGroup}</td>
              <td>${row.CtypeName}</td>
              <td>${row.IntervalDays} days</td>
              <td>${datePart(row.LastCalibrationDate)}</td>
              <td>${datePart(row.NextDueDate)}</td>
              <td>${row.Status}</td>
              <td>${row.CalibrationLoc}</td>
              <td>${row.Responsibility}</td>
          `;
      } else if (type === 'item') {
          cells = `
              <td>${row.PartNo}</td>
              <td>${row.PartDesc}</td>
              <td>${row.Wcname}</td>
              <td>${row.maxqty}</td>
              <td>${row.calibrationqty}</td>
          `;
      } else if (type === 'spare') {
          cells = `
              <td>${row.PartNo}</td>
              <td>${row.PartDesc}</td>
              <td>${row.category}</td>
              <td>${row.StoresQty}</td>
              <td>${row.Frequency}</td>
          `;
      }
      return '<tr>' + cells + '</tr>';
    }).join('');
  };

  const calibrationHeaders = ['Calibration Group','Type', 'Interval', 'Last Cal. Date', 'Next Due Date', 'Status', 'Location', 'Responsibility'];
  const itemHeaders = ['Part No', 'Description', 'Work Center', 'Max Qty', 'Calibiration Qty'];
  const spareHeaders = ['Part No', 'Description', 'Category', 'Stores Qty', 'Frequency'];

//  <img src="${logoSrc}" alt="Company Logo" class="company-logo" />
  const htmlContent = `
    <html>
    <head>
    <meta charset="UTF-8" />
      <title>Asset Print: ${main.AssetNo} - ${main.AssetName}</title>
      <style>
        @page { size: A4; margin: 20mm; }
        body { font-family: Arial, sans-serif; margin: 0; padding: 0; color: #333; font-size: 10pt; }
        .print-container { max-width: 100%; margin: 0 auto; padding: 0; }
        h1, h2 { text-align: center; margin-top: 0; }
        h1 { font-size: 1.5rem; margin-bottom: 5px; }
        h2 { font-size: 1.2rem; margin-top: 20px; border-bottom: 2px solid #333; padding-bottom: 5px; text-align: left; }
        p { text-align: center; color: #6b7280; margin-bottom: 20px; }
        /* Forces Page Break after the main asset details (Page 1) */
        .asset-details-page { page-break-after: always; padding-bottom: 20px; }
        .print-details-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px 20px;
          margin-bottom: 20px;
          border: 1px solid #ddd;
          padding: 15px;
          border-radius: 8px;
        }
        .print-detail-item { font-size: 10pt; }
        .print-detail-item strong { display: block; font-size: 11pt; color: #333; margin-bottom: 2px; font-weight: bold; }
        
        .data-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .data-table th, .data-table td { padding: 8px; text-align: left; border: 1px solid #e5e7eb; font-size: 9pt; }
        .data-table th { background-color: #f3f4f6; color: #6b7280; text-transform: uppercase; font-size: 8pt; letter-spacing: 0.05em; font-weight: 600; }
        .report-footer { margin-top: 50px; font-size: 8pt; color: #6b7280; text-align: right; }
        
        /* New style for company name/header */
        .print-header-company { text-align: center; font-size: 1.8rem; font-weight: bold; color: #1f2937; margin-bottom: 10px; }
.print-header-container {
  display: flex;
  align-items: center;
  gap: 15px; /* space between logo and company name */
  margin-bottom: 20px;
}

.print-header-container img.company-logo {
  height: 70px; /* adjust logo height */
  width: auto;
}

.print-header-company {
  flex: 1;
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #1f2937;
  margin: 0;
}


      </style>
    </head>
    <body>
      <div class="print-container">
        <div class="asset-details-page">

         <div class="print-header-container">
 
  <p class="print-header-company">${companyName || 'ASSET MANAGEMENT REPORT'}</p>
  
  
</div>
          <h1 style="text-align:center;">Asset Detail Report   </h1>
          <p style="text-align:center;"><strong>${main.AssetName} (${main.AssetNo})</strong></p>

         <div class="print-details-grid">

  <div class="print-detail-item"><strong>Asset No:</strong> ${main.AssetNo}</div>
  <div class="print-detail-item"><strong>Ownership:</strong> ${main.Ownership}</div>

  <div class="print-detail-item"><strong>Asset Name:</strong> ${main.AssetName}</div>
  <div class="print-detail-item"><strong>Project Name:</strong> ${main.ProjectName}</div>

  <div class="print-detail-item"><strong>Own By:</strong> ${main.OwnBy}</div>
  <div class="print-detail-item"></div>

  <div class="print-detail-item"><strong>Serial No:</strong> ${main.SerialNo}</div>
  <div class="print-detail-item"><strong>Model:</strong> ${main.Model}</div>

  <div class="print-detail-item"><strong>Esti. Run/Unit:</strong> ${main.EstRuning_Unit}</div>
  <div class="print-detail-item"><strong>Capacity/Unit:</strong> ${main.Capacity_Unit}</div>

  <div class="print-detail-item"><strong>Specification:</strong> ${main.Specification}</div>
  <div class="print-detail-item"><strong>Manufacturer:</strong> ${main.Manufacture}</div>

  <div class="print-detail-item"><strong>Asset Type:</strong> ${main.AssetType}</div>
  <div class="print-detail-item"><strong>Asset Condition:</strong> ${main.AssetCondition}</div>

  <div class="print-detail-item"><strong>WorkCenter:</strong> ${main.WorkCenter}</div>
  <div class="print-detail-item"><strong>Department:</strong> ${main.Department}</div>

  <div class="print-detail-item"><strong>EPCG License No:</strong> ${main.EpcgLicenseNo}</div>
  <div class="print-detail-item"><strong>A/C Code:</strong> ${main.AcCode}</div>

  <div class="print-detail-item"><strong>Original Size:</strong> ${main.OriginalSize}</div>
  <div class="print-detail-item"><strong>Supplier Name:</strong> ${main.SupplierName}</div>

  <div class="print-detail-item"><strong>Invoice No:</strong> ${main.InvNo}</div>
  <div class="print-detail-item"><strong>Inv Date:</strong> ${datePart(main.InvDate)}</div>

  <div class="print-detail-item"><strong>PO No:</strong> ${main.PoNo}</div>
  <div class="print-detail-item"><strong>PO Date:</strong> ${datePart(main.PoDate)}</div>

  <div class="print-detail-item"><strong>Asset Made:</strong> ${main.AssetMade}</div>
  <div class="print-detail-item"><strong>Purchase Price:</strong> ${main.PurchasePrize}</div>

  <div class="print-detail-item"><strong>Current Value:</strong> ${main.CurrentValue}</div>
  <div class="print-detail-item"><strong>Checkup Frequency:</strong> ${main.CheckupFrequency}</div>

  <div class="print-detail-item"><strong>Current Location:</strong> ${main.CurrentLocation}</div>
  <div class="print-detail-item"><strong>Current Status:</strong> ${main.CurrentStatus}</div>

</div>

        </div>
        <h2>Calibration Details </h2>
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>${calibrationHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${generateTableRows(calibrations, calibrationHeaders, 'calibration')}
            </tbody>
          </table>
        </div>

        <h2> Production by Part</h2>
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>${itemHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${generateTableRows(items, itemHeaders, 'item')}
            </tbody>
          </table>
        </div>
        
        <h2> Spares & Consumables</h2>
        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>${spareHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${generateTableRows(spares, spareHeaders, 'spare')}
            </tbody>
          </table>
        </div>

        <div class="report-footer">
          <p>Report Generated: ${new Date().toLocaleString()}</p>
          <p>Generated by: ${main.UserName || 'System'}</p>
        </div>
        </div>

      <script>
        // Auto-print logic in the new window
        window.onload = function() {
            // Use a small delay to ensure all content is rendered before printing
            setTimeout(function() {
              //  window.print();
            }, 500); 
        };
      </script>

    </body>
    </html>
  `;
  
  return htmlContent;
};




// export const getCalibrationPrintHtml = (assetData, companyName,logoSrc) => {
//   if (!assetData || !assetData.main) {
//     return "<html><body><p style='color:red; text-align:center;'>Asset data is not available for printing.</p></body></html>";
//   }

//   const main = assetData.main;
//   const calibrations = assetData.calibrations || [];
//   const items = assetData.items || [];
//   const spares = assetData.spares || [];
//   const datePart = (dateStr) => dateStr?.split('T')[0] || '-';

//   const generateTableRows = (data, headers, type) => {
//     if (data.length === 0) return `<tr><td colspan="${headers.length}" style="text-align:center; color:#9ca3af;">No ${type} data available.</td></tr>`;
    
//     return data.map(row => {
//       let cells = '';

//       if (type === 'calibration') {
//           cells = `
//           <td>${row.CalibrationGroup}</td>
//               <td>${row.CtypeName}</td>
//               <td>${row.IntervalDays} days</td>
//               <td>${datePart(row.LastCalibrationDate)}</td>
//               <td>${datePart(row.NextDueDate)}</td>
//               <td>${row.Status}</td>
//               <td>${row.CalibrationLoc}</td>
//               <td>${row.Responsibility}</td>
//           `;
//       } else if (type === 'item') {
//           cells = `
//               <td>${row.PartNo}</td>
//               <td>${row.PartDesc}</td>
//               <td>${row.Wcname}</td>
//               <td>${row.maxqty}</td>
//               <td>${row.calibrationqty}</td>
//           `;
//       } else if (type === 'spare') {
//           cells = `
//               <td>${row.PartNo}</td>
//               <td>${row.PartDesc}</td>
//               <td>${row.category}</td>
//               <td>${row.StoresQty}</td>
//               <td>${row.Frequency}</td>
//           `;
//       }
//       return '<tr>' + cells + '</tr>';
//     }).join('');
//   };

//   const calibrationHeaders = ['Calibration Group','Type', 'Interval', 'Last Cal. Date', 'Next Due Date', 'Status', 'Location', 'Responsibility'];
//   const itemHeaders = ['Part No', 'Description', 'Work Center', 'Max Qty', 'Calibiration Qty'];
//   const spareHeaders = ['Part No', 'Description', 'Category', 'Stores Qty', 'Frequency'];


//   const htmlContent = `
//     <html>
//     <head>
//       <title>Asset Print: ${main.AssetNo} - ${main.AssetName}</title>
//       <style>
//         @page { size: A4; margin: 20mm; }
//         body { font-family: Arial, sans-serif; margin: 0; padding: 0; color: #333; font-size: 10pt; }
//         .print-container { max-width: 100%; margin: 0 auto; padding: 0; }
//         h1, h2 { text-align: center; margin-top: 0; }
//         h1 { font-size: 1.5rem; margin-bottom: 5px; }
//         h2 { font-size: 1.2rem; margin-top: 20px; border-bottom: 2px solid #333; padding-bottom: 5px; text-align: left; }
//         p { text-align: center; color: #6b7280; margin-bottom: 20px; }
//         /* Forces Page Break after the main asset details (Page 1) */
//         .asset-details-page { page-break-after: always; padding-bottom: 20px; }
//         .print-details-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 10px 20px;
//           margin-bottom: 20px;
//           border: 1px solid #ddd;
//           padding: 15px;
//           border-radius: 8px;
//         }
//         .print-detail-item { font-size: 10pt; }
//         .print-detail-item strong { display: block; font-size: 11pt; color: #333; margin-bottom: 2px; font-weight: bold; }
        
//         .data-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
//         .data-table th, .data-table td { padding: 8px; text-align: left; border: 1px solid #e5e7eb; font-size: 9pt; }
//         .data-table th { background-color: #f3f4f6; color: #6b7280; text-transform: uppercase; font-size: 8pt; letter-spacing: 0.05em; font-weight: 600; }
//         .report-footer { margin-top: 50px; font-size: 8pt; color: #6b7280; text-align: right; }
        
//         /* New style for company name/header */
//         .print-header-company { text-align: center; font-size: 1.8rem; font-weight: bold; color: #1f2937; margin-bottom: 10px; }
// .print-header-container {
//   display: flex;
//   align-items: center;
//   gap: 15px; /* space between logo and company name */
//   margin-bottom: 20px;
// }

// .print-header-container img.company-logo {
//   height: 70px; /* adjust logo height */
//   width: auto;
// }

// .print-header-company {
//   flex: 1;
//   text-align: center;
//   font-size: 1.8rem;
//   font-weight: bold;
//   color: #1f2937;
//   margin: 0;
// }


//       </style>
//     </head>
//     <body>
//       <div class="print-container">
//         <div class="asset-details-page">

//          <div class="print-header-container">
//   <img src="${logoSrc}" alt="Company Logo" class="company-logo" />
//   <p class="print-header-company">${companyName || 'ASSET MANAGEMENT REPORT'}</p>
// </div>
//           <h1 style="text-align:center;">Asset Detail Report - ${main.AssetNo} </h1>
//           <p style="text-align:center;"><strong>${main.AssetName} (${main.SerialNo})</strong></p>

//          <div class="print-details-grid">

//   <div class="print-detail-item"><strong>Asset No:</strong> ${main.AssetNo}</div>
//   <div class="print-detail-item"><strong>Ownership:</strong> ${main.Ownership}</div>

//   <div class="print-detail-item"><strong>Asset Name:</strong> ${main.AssetName}</div>
//   <div class="print-detail-item"><strong>Project Name:</strong> ${main.ProjectName}</div>

//   <div class="print-detail-item"><strong>Own By:</strong> ${main.OwnBy}</div>
//   <div class="print-detail-item"></div>

//   <div class="print-detail-item"><strong>Serial No:</strong> ${main.SerialNo}</div>
//   <div class="print-detail-item"><strong>Model:</strong> ${main.Model}</div>

//   <div class="print-detail-item"><strong>Esti. Run/Unit:</strong> ${main.EstRuning_Unit}</div>
//   <div class="print-detail-item"><strong>Capacity/Unit:</strong> ${main.Capacity_Unit}</div>

//   <div class="print-detail-item"><strong>Specification:</strong> ${main.Specification}</div>
//   <div class="print-detail-item"><strong>Manufacturer:</strong> ${main.Manufacture}</div>

//   <div class="print-detail-item"><strong>Asset Type:</strong> ${main.AssetType}</div>
//   <div class="print-detail-item"><strong>Asset Condition:</strong> ${main.AssetCondition}</div>

//   <div class="print-detail-item"><strong>WorkCenter:</strong> ${main.WorkCenter}</div>
//   <div class="print-detail-item"><strong>Department:</strong> ${main.Department}</div>

//   <div class="print-detail-item"><strong>EPCG License No:</strong> ${main.EpcgLicenseNo}</div>
//   <div class="print-detail-item"><strong>A/C Code:</strong> ${main.AcCode}</div>

//   <div class="print-detail-item"><strong>Original Size:</strong> ${main.OriginalSize}</div>
//   <div class="print-detail-item"><strong>Supplier Name:</strong> ${main.SupplierName}</div>

//   <div class="print-detail-item"><strong>Invoice No:</strong> ${main.InvNo}</div>
//   <div class="print-detail-item"><strong>Inv Date:</strong> ${datePart(main.InvDate)}</div>

//   <div class="print-detail-item"><strong>PO No:</strong> ${main.PoNo}</div>
//   <div class="print-detail-item"><strong>PO Date:</strong> ${datePart(main.PoDate)}</div>

//   <div class="print-detail-item"><strong>Asset Made:</strong> ${main.AssetMade}</div>
//   <div class="print-detail-item"><strong>Purchase Price:</strong> ${main.PurchasePrize}</div>

//   <div class="print-detail-item"><strong>Current Value:</strong> ${main.CurrentValue}</div>
//   <div class="print-detail-item"><strong>Checkup Frequency:</strong> ${main.CheckupFrequency}</div>

//   <div class="print-detail-item"><strong>Current Location:</strong> ${main.CurrentLocation}</div>
//   <div class="print-detail-item"><strong>Current Status:</strong> ${main.CurrentStatus}</div>

// </div>

//         </div>
//         <h2>Calibration Details </h2>
//         <div class="table-wrapper">
//           <table class="data-table">
//             <thead>
//               <tr>${calibrationHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
//             </thead>
//             <tbody>
//               ${generateTableRows(calibrations, calibrationHeaders, 'calibration')}
//             </tbody>
//           </table>
//         </div>

//         <h2> Production by Part</h2>
//         <div class="table-wrapper">
//           <table class="data-table">
//             <thead>
//               <tr>${itemHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
//             </thead>
//             <tbody>
//               ${generateTableRows(items, itemHeaders, 'item')}
//             </tbody>
//           </table>
//         </div>
        
//         <h2> Spares & Consumables</h2>
//         <div class="table-wrapper">
//           <table class="data-table">
//             <thead>
//               <tr>${spareHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
//             </thead>
//             <tbody>
//               ${generateTableRows(spares, spareHeaders, 'spare')}
//             </tbody>
//           </table>
//         </div>

//         <div class="report-footer">
//           <p>Report Generated: ${new Date().toLocaleString()}</p>
//           <p>Generated by: ${main.UserName || 'System'}</p>
//         </div>
//         </div>

//       <script>
//         // Auto-print logic in the new window
//         window.onload = function() {
//             // Use a small delay to ensure all content is rendered before printing
//             setTimeout(function() {
//               //  window.print();
//             }, 500); 
//         };
//       </script>

//     </body>
//     </html>
//   `;
  
//   return htmlContent;
// };


